import React from 'react';
import PropTypes from 'prop-types';
import { loadShow } from './';

class ShowProvider extends React.Component {
  constructor(props) {
    super(props);
    loadShow(props.show);
  }

  render() {
    return this.props.children;
  }
}
ShowProvider.propTypes = {
  show: PropTypes.oneOfType([PropTypes.any]),
  children: PropTypes.element
};
ShowProvider.defaultProps = {
  children: null,
  show: {}
};

export default ShowProvider;
